import React, { createContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

// Components
import LoadingArea from '@molecules/LoadingArea';

// Helpers
import useEvent from '../../../../hooks/useEvent';

export const EventDetailProvider = createContext();
export const eventDetailSubviews = {
    SESSIONS: {
        order: 1,
        label: 'Sessions List',
        key: 'sessions',
    },
    AGENDA: {
        order: 2,
        label: 'My Agenda',
        key: 'agenda',
    },
    // AVAILABILITY: {
    //     order: 3,
    //     label: 'My Availability',
    //     key: 'availability',
    // },
};

const EventDetailProviderWrapper = ({ children, subview }) => {
    const { eventSlug, sessionSlug } = useParams();
    const [defaultView] = useState(subview || 'sessions');
    const event = useEvent(eventSlug);

    if (!event) {
        return <LoadingArea />;
    }

    return (
        <EventDetailProvider.Provider
            value={{
                defaultView,
                event,
                eventSlug,
                sessionSlug,
            }}
        >
            {children}
        </EventDetailProvider.Provider>
    );
};

EventDetailProviderWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    subview: PropTypes.oneOf([
        '',
        ...Object.keys(eventDetailSubviews).map(subview => eventDetailSubviews[subview].key),
    ]),
};

export default EventDetailProviderWrapper;
